<script>
  import '../../app.css';

  import { page } from '$app/stores';
  import TheHeader from '$components/TheHeader/TheHeader.svelte';
  import TheFooter from '$components/TheFooter/TheFooter.svelte';
  import SiteNotice from '$components/SiteNotice/SiteNotice.svelte';
  import PageNotice from '$components/PageNotice/PageNotice.svelte';
  import SearchOverpanel from '$components/SearchOverpanel/SearchOverpanel.svelte';
  import LocationOverpanel from '$components/LocationOverpanel/LocationOverpanel.svelte';
  import FeedbackOverpanel from '$components/FeedbackOverpanel/FeedbackOverpanel.svelte';
  import UseBodyOverflowHidden from '$utils/UseBodyOverflowHidden.svelte';
  import SetQueryReferrer from '$utils/SetQueryReferrer.svelte';
  import SetDocumentReferrer from '$utils/SetDocumentReferrer.svelte';
  import { isHeaderMenuOpen } from '$stores/headerMenu';
  import { overpanelMap } from '$stores/overpanelControl';
  import { handleLangURLs } from '$utils/handleLangURLs';
  import { buildURL } from '$utils/route-utils';
  import { buildMeta } from '$utils/metaData';
  import { buildTitle } from '$utils/buildTitle';
  import RestoreLocation from '$utils/RestoreLocation.svelte';
  import { handleRetentionEmail } from '$utils/retention-email';

  let { data, children } = $props();
  const lang = data.lang;

  const normalizedMeta = buildMeta({ global: data.social, ...$page.data.meta });
  const title = buildTitle(
    $page.data.meta && $page.data.meta.section ? $page.data.meta.section.siteTitle : data.social.siteTitle,
    $page.data.pageSubtitle
  );

  handleRetentionEmail(lang);

  let { englishLink, spanishLink } = $derived.by(() => {
    if (!$page.data.englishLink && !$page.data.spanishLink) {
      return handleLangURLs($page.data.path, $page.data.query);
    } else {
      return {
        englishLink: $page.data.englishLink, 
        spanishLink: $page.data.spanishLink
      }
    }
  }); 
  
  const domain = process.env.DOMAIN;
  const fullPath = buildURL($page.data.path, $page.data.query);
  const englishHrefLang = $derived(`${
    englishLink
      ? buildURL($page.data.englishLinkOverride || englishLink.url)
      : $page.data.englishLinkOverride || fullPath
  }`);
  const spanishHreflang = $derived(`${
    spanishLink
      ? buildURL($page.data.spanishLinkOverride || spanishLink.url)
      : $page.data.spanishLinkOverride || fullPath
  }`);
  const canonicalURL = `${domain}${$page.data.canonicalUrl ? $page.data.canonicalUrl : fullPath}`;
</script>

<svelte:head>
  <base href={process.env.APP_BASEPATH} rel="external" />
  <title>{title}</title>
  {#each normalizedMeta as entry, index (index)}
    <meta {...entry} />
  {/each}
  {#if spanishHreflang}
    <link rel="alternate" hreflang="es-us" href={`${domain}${spanishHreflang}`} />
  {/if}
  {#if englishHrefLang || canonicalURL === domain || `${domain}/es`}
    <link rel="alternate" hreflang="en-us" href={`${domain}${englishHrefLang}`} />
  {/if}
  <link rel="alternate" hreflang="x-default" href={`${domain}${englishHrefLang}`} />
  <link rel="canonical" href={canonicalURL} />
  {@html `<html lang=${lang}-us />`}
</svelte:head>

{@html data.structuredContent.jsonld}

<SetQueryReferrer />
<SetDocumentReferrer />
<RestoreLocation />

{#if $isHeaderMenuOpen || Array.from($overpanelMap.keys()).length}
  <UseBodyOverflowHidden />
{/if}

{#if $page.data.pageNotice}
  <PageNotice {...$page.data.pageNotice} />
{/if}
{#if data.siteNotice}
  <SiteNotice {...data.siteNotice} />
{/if}

<TheHeader {...data.theHeader} {englishLink} {spanishLink} {lang} query={$page.data.query} path={$page.data.path} />

<main id="main-content">
  {@render children?.()}
</main>
<TheFooter
  {...data.theFooter}
  {englishLink}
  {spanishLink}
  {lang}
  pageDisclaimer={$page.data.pageDisclaimer || ($page.data.content && $page.data.content.pageDisclaimer)}
  hideGlobalDisclaimer={$page.data.hideGlobalDisclaimer}
/>

<SearchOverpanel {...data.searchOverpanel} {lang} />
<LocationOverpanel {...data.locationOverpanel} />
<FeedbackOverpanel {...data.feedbackOverpanel} {...data.helpFeedbackOverpanel} {lang} />
